import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import Image from "../../Utils/getImage";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { toast } from "react-toastify";
import instance from "../../Utils/api";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import AutorenewIcon from "@mui/icons-material/Autorenew";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ApproveManequinDialog from "./ApproveManequinDialog";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import GetLink from "../../Utils/GetLink";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const SubOrder_details = ({ subOrder, juniorAdmins, staff, fetchSubOrderDetailsById }) => {
  const [adminId, setadminId] = useState("");
  const [status, setstatus] = useState("");
  const [deadline, setDeadline] = useState(null);
  const [amount, setAmount] = useState(null);
  const [master, setMaster] = useState(null);
  const [tailor, setTailor] = useState(null);
  const [maggamWorker, setMaggamWorker] = useState(null);
  const [deliveryboy, setDeliveryboy] = useState(null);
  const [documents, setDocuments] = useState(null);
  const [sheet, setSheet] = useState(null);
  const [finalImage, setFinalImage] = useState(null);
  const [currentStep, setCurrentStep] = useState(subOrder?.step || 0);
  const [openConsultationDialog, setOpenConsultationDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [buttondis, setButtondis] = useState(false);
  const [openViewMoreDialog, setOpenViewMoreDialog] = useState(false);
  const role = localStorage.getItem('role');
  const [errors, setErrors] = useState({
    adminId: "",
    deadline: "",
    documents: "",
    sheet: "",
    amount: "",
    master: "",
    tailor: "",
    maggamWorker: "",
    finalImage: "",
    deliveryboy: "",
  });

  // const [staffId, setStaffId] = useState(() => {
  //     if (subOrder?.staff && Array.isArray(subOrder.staff)) {
  //         return subOrder.staff.map((s) => (typeof s === "string" ? s : s.staffId)); // Ensure correct mapping
  //     }
  //     return []; // Default to empty array if no staff exist
  // });

  const [comment, setcomment] = useState(null);

  useEffect(() => {
    setCurrentStep(subOrder?.step);
  }, [subOrder])
  const statuses = [
    ,
    "In Progress",
    "In Transit",
    "Completed",
    "Canceled",
    "Delivered",
    "Alteration",
  ];
  const statusRestrictions = {
    Unassigned: statuses,
    Assigned: statuses,
    "In Payment": statuses,
    "In Progress": statuses.filter((status) => status !== "In Payment"),
    "In Transit": statuses.filter(
      (status) => !["In Payment", "In Progress"].includes(status)
    ),
    Completed: statuses.filter(
      (status) => !["In Payment", "In Progress", "In Transit"].includes(status)
    ),
    Delivered: statuses.filter(
      (status) => !["In Payment", "In Progress", "In Transit"].includes(status)
    ),
    Canceled: statuses,
    Alteration: statuses,
  };

  const filteredStatuses = status
    ? statusRestrictions[subOrder?.status]
    : statuses;


  useEffect(() => {
    setadminId(subOrder?.adminId);
    setstatus(subOrder?.status);
    setDeadline(subOrder?.deadline)
    setAmount(subOrder?.amount);
    setcomment(subOrder?.comment);
  }, [subOrder]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const fieldName = e.target.name;

    if (fieldName === "documents") {
      setDocuments(file);
      clearError("documents");
    }

    if (fieldName === "sheet") {
      setSheet(file);
      clearError("sheet");
    }
  };

  const handleFileChangeimage = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFinalImage(file);
    }
    setErrors((prev) => ({ ...prev, finalImage: "" }));
  };

  const handelCancelOrder = (id) => {
    setSelectedId(id);
    setOpenConsultationDialog(true);
  };

  const handleClose = () => {
    setOpenConsultationDialog(false);
    setSelectedId(null);
  };

  const validationform = () => {
    let newErrors = {};
    let isValid = true;

    if (currentStep === 0) {
      if (!adminId && !subOrder?.assigned_to?._id) {
        newErrors.adminId = "Please assign a junior designer";
        isValid = false;
      }

      if (!deadline && !subOrder?.deadline) {
        newErrors.deadline = "Please select a deadline";
        isValid = false;
      }

      if (!documents && !subOrder?.documents?.length) {
        newErrors.documents = "Document is required";
      }

      if (!sheet && !subOrder?.sheet) {
        newErrors.sheet = "Sheet is required";
        isValid = false;
      }

      if (!amount && !subOrder?.amount) {
        newErrors.amount = "Cost is required";
        isValid = false;
      }
    }

    if (currentStep === 1) {
      if (!master && !subOrder?.Master) {
        newErrors.master = "Assign a Master";
        isValid = false;
      }

      if (!tailor && !subOrder?.Tailor) {
        newErrors.tailor = "Assign a Tailor";
        isValid = false;
      }

      if (!maggamWorker && !subOrder?.MaggamWorker) {
        newErrors.maggamWorker = "Assign a Maggam Worker";
        isValid = false;
      }
    }

    if (currentStep === 2 && !subOrder?.final_image) {
      if (!finalImage) {
        newErrors.finalImage = "Final image required";
        isValid = false;
      }
    }

    if (currentStep === 3 && !subOrder?.DeliveryBoy) {
      if (!deliveryboy) {
        newErrors.deliveryboy = "Assign Delivery Boy";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const clearError = (field) => {
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleupdateorder = async (order_id, Delivered, Canceled) => {
    // if (!validationform()) return;
    if (!Canceled) {
      if (!validationform()) return;
    }
    const formData = new FormData();
    formData.append("order_id", order_id);

    let isUpdated = false;

    if (Delivered) {
      formData.append("Delivered", Delivered);
      isUpdated = true;
    }
    if (Canceled) {
      formData.append("Canceled", Canceled);
      isUpdated = true;
    }
    if (status && status !== subOrder?.status) {
      formData.append("status", status);
      isUpdated = true;
    }
    if (adminId && adminId !== subOrder?.assigned_to?._id) {
      formData.append("admin_id", adminId);
      isUpdated = true;
    }
    if (deadline && deadline !== subOrder?.deadline) {
      formData.append("deadline", deadline);
      isUpdated = true;
    }
    if (amount && amount !== subOrder?.amount) {
      formData.append("amount", amount);
      isUpdated = true;
    }
    if (master && master !== subOrder?.Master) {
      formData.append("Master", master);
      isUpdated = true;
    }
    if (tailor && tailor !== subOrder?.Tailor) {
      formData.append("Tailor", tailor);
      isUpdated = true;
    }
    if (maggamWorker && maggamWorker !== subOrder?.MaggamWorker) {
      formData.append("MaggamWorker", maggamWorker);
      isUpdated = true;
    }
    if (deliveryboy && deliveryboy !== subOrder?.DeliveryBoy) {
      formData.append("DeliveryBoy", deliveryboy);
      isUpdated = true;
    }
    if (documents instanceof File) {
      formData.append("documents", documents);
      isUpdated = true;
    }
    if (sheet instanceof File) {
      formData.append("sheet", sheet);
      isUpdated = true;
    }
    if (finalImage instanceof File) {
      formData.append("final_image", finalImage);
      isUpdated = true;
    }
    // if (staffId.length > 0) {
    //     staffId.forEach((id) => formData.append("staff", id));
    //     isUpdated = true;
    // }
    if (comment && comment !== subOrder?.comment) {
      formData.append("comment", comment);
      isUpdated = true;
    }

    try {
      setButtondis(true);
      const response = await instance.patch("/Order/updateSubOrder", formData);
      if (response.data.success === true) {
        toast.success(response.data.message);
        fetchSubOrderDetailsById();
        setCurrentStep(response.data.data.step);
        setOpenConsultationDialog(false);
      } else {
        toast.error(response?.data?.message || response?.data?.error);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setButtondis(false);
    }
  };

  const steps = [
    "Assign Designer",
    "Assign Tailors",
    "Upload Mannequin",
    "Delivery",
  ];
  const shouldShowActionButtons = () => {
    if (['Order Canceled', 'Order Delivered', 'Delivery Scheduled'].includes(subOrder?.status)) return false;
    if (subOrder?.status === 'Order Processed') return !subOrder.DeliveryBoy;
    return true;
  };

  const finalImageApprove = async () => {
    try {
      const response = await instance.patch(
        `/Order/${subOrder._id}/approve-image`
      );
      if (response.status === 200) {
        toast.success(response.data.message);
        fetchSubOrderDetailsById();
      }
    } catch (err) {
      toast.error("Failed to Approve", err.data.message);
    }
  };

  const statusConfig = {
    'Order Delivered': {
      icon: <CheckCircleOutlineOutlinedIcon />,
      message: 'Order Delivered Successfully',
      className: 'status-delivered',
    },
    'Delivery Scheduled': {
      icon: <AutorenewIcon />,
      message: 'Order is Being Scheduled for Delivery',
      className: 'status-processing',
    },
    'Order Processed': {
      icon: <AutorenewIcon />,
      message: 'Order is Being Processed',
      className: 'status-processing',
    },
    'Order Canceled': {
      icon: <CancelOutlinedIcon />,
      message: 'This Order has been Canceled',
      className: 'status-canceled',
    },
    'Default': {
      icon: <HelpOutlineIcon />,
      message: 'Status Unknown',
      className: 'status-unknown',
    }
  };

  const OrderStatusDisplay = ({ status }) => {
    // Get the configuration for the current status, or fall back to a default
    const { icon, message, className } = statusConfig[status] || statusConfig.Default;

    return (
      <Box className={`order-status-display ${className}`}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <div className="status-icon-wrapper">
            {icon}
          </div>
          <Typography variant="h6" component="p" className="status-message">
            {message}
          </Typography>
        </Stack>
      </Box>
    );
  };

  const handleViewMore = async () => {
    await fetchSubOrderDetailsById();
    setOpenViewMoreDialog(true);
  };

  const handleCloseViewMore = () => {
    setOpenViewMoreDialog(false);
  };

  return (
    <div>
      <Box className="sub-order-container">
        <Grid container spacing={3}>

          <Grid item size={{ xs: 12, md: 4, lg: 4, xl: 4 }}>
            <div className="info-card">
              <div className="account-details-view">
                <Typography variant="h6">Order Details</Typography>
                <Button onClick={handleViewMore}>view More</Button>
              </div>

              <div className="product-image-wrapper">
                <Swiper
                  spaceBetween={20}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  modules={[Autoplay, Pagination]}
                  pagination={{ clickable: true }}
                  loop={true}
                  className="product-swiper"
                >
                  {subOrder?.design_id?.picture?.length > 0 ? (
                    subOrder.design_id.picture.map((pictureUrl, index) => (
                      <SwiperSlide key={index}>
                        {pictureUrl ? (
                          <div className="swiper-image-container">
                            <Image
                              src={pictureUrl}
                              alt={subOrder?.design_id?.name || "Product Image"}
                              width={230}
                              height={230}
                              className="swiper-image"
                            />
                          </div>
                        ) : (
                          <p className="no-image-text">No image available</p>
                        )}
                      </SwiperSlide>
                    ))
                  ) : (
                    <p className="no-image-text">No images available</p>
                  )}
                </Swiper>
              </div>

              <div>
                <Typography variant="h5" >{subOrder?.design_id?.name}</Typography>
                <dl className="details-list">
                  <div className="detail-item">
                    <dt>Order ID</dt>
                    <dd>{subOrder?.sub_order_id}</dd>
                  </div>
                  <div className="detail-item">
                    <dt>Quantity</dt>
                    <dd>{subOrder?.quantity}</dd>
                  </div>
                  <div className="detail-item">
                    <dt>Size</dt>
                    <dd>{subOrder?.size}</dd>
                  </div>
                  <div className="detail-item">
                    <dt>Deadline</dt>
                    <dd>
                      {subOrder?.deadline
                        ? dayjs(subOrder.deadline).format("DD-MM-YYYY")
                        : "---"}
                    </dd>
                  </div>
                  <div className="detail-item">
                    <dt>Status</dt>
                    <dd>{subOrder?.status}</dd>
                  </div>
                  <div className="detail-item">
                    <dt>OrderFor</dt>
                    <dd>{subOrder?.ordered_for || ""}</dd>
                  </div>
                  <div className="detail-item">
                    <dt>Description</dt>
                    <dd className="description-text">{subOrder?.design_id?.description || ""}</dd>
                  </div>
                </dl>
              </div>
            </div>
          </Grid>

          <Grid item size={{ xs: 12, md: 8, lg: 8, xl: 8 }}>
            <Grid container spacing={2}>
              <Grid item size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                <div className="info-card">
                  <Typography variant="h6" className="card-title">Production Workflow</Typography>

                  <div className="stepper-wrapper-order">
                    {steps.map((step, index) => (
                      <div key={index} className={`stepper-item ${index < currentStep ? "completed" : ""} ${index === currentStep ? "active" : ""}`}>
                        <div className="step-counter"></div>
                        <div className="step-name">{step}</div>
                      </div>
                    ))}
                  </div>

                  <Grid container spacing={2}>
                    {currentStep === 0 && (
                      <>
                        {role === "JuniorDesigner" ? null : (
                          <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                            <div className="admin-textfiled">
                              <FormControl
                                fullWidth
                                required
                                disabled={role === "JuniorDesigner"}
                                error={!!errors.adminId}
                              >
                                <InputLabel id="demo-simple-select-label">
                                  Assign to jr.Designer
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  label="Assign to jr.Designer"
                                  value={adminId || subOrder?.assigned_to?._id}
                                  onChange={(e) => {
                                    setadminId(e.target.value);
                                    clearError("adminId");
                                  }}
                                >
                                  {juniorAdmins?.map((data) => (
                                    <MenuItem value={data?.employeeId}>
                                      {data.employeeName}
                                    </MenuItem>
                                  ))}
                                </Select>
                                {errors.adminId && (<FormHelperText>{errors.adminId}</FormHelperText>)}
                              </FormControl>
                            </div>
                          </Grid>
                        )}

                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                          <div className="admin-textfiled">
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                              <DatePicker
                                disabled={role === "JuniorDesigner"}
                                label="Select Deadline"
                                format="DD/MM/YYYY"
                                value={
                                  deadline
                                    ? dayjs(deadline)
                                    : subOrder?.deadline
                                      ? dayjs(subOrder.deadline)
                                      : null
                                }
                                onChange={(newValue) => {
                                  setDeadline(newValue?.hour(12).minute(0).second(0).millisecond(0));
                                  clearError("deadline");
                                }}
                                minDate={dayjs()}
                              />
                              {errors.deadline && (
                                <FormHelperText error>{errors.deadline}</FormHelperText>
                              )}
                            </LocalizationProvider>
                          </div>
                        </Grid>

                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                          <div className="admin-textfiled">
                            <FormControl fullWidth required error={!!errors.documents}>
                              <TextField
                                label="Documents"
                                type="file"
                                required
                                name="documents"
                                onChange={handleFileChange}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ accept: "image/*,.pdf" }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    // Normal border
                                    borderRadius: "8px",

                                    // 🔥 RED BORDER WHEN ERROR EXISTS
                                    ...(errors.documents && {
                                      "& fieldset": {
                                        borderColor: "red !important",
                                      },
                                      "&:hover fieldset": {
                                        borderColor: "red !important",
                                      },
                                      "&.Mui-focused fieldset": {
                                        borderColor: "red !important",
                                      },
                                    }),
                                  },
                                }}
                              />
                              {errors.documents && (
                                <FormHelperText error>{errors.documents}</FormHelperText>
                              )}
                            </FormControl>
                          </div>
                        </Grid>

                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                          <div className="admin-textfiled">
                            <FormControl fullWidth required error={!!errors.sheet}>
                              <TextField
                                label="Upload Measurement Sheet"
                                type="file"
                                name="sheet"
                                required
                                onChange={handleFileChange}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ accept: "image/*,.pdf" }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    // Normal border
                                    borderRadius: "8px",

                                    // 🔥 RED BORDER WHEN ERROR EXISTS
                                    ...(errors.documents && {
                                      "& fieldset": {
                                        borderColor: "red !important",
                                      },
                                      "&:hover fieldset": {
                                        borderColor: "red !important",
                                      },
                                      "&.Mui-focused fieldset": {
                                        borderColor: "red !important",
                                      },
                                    }),
                                  },
                                }}
                              />
                              {errors.sheet && <FormHelperText>{errors.sheet}</FormHelperText>}
                            </FormControl>
                          </div>
                        </Grid>

                        {role === "JuniorDesigner" ? null : (
                          <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                            <div className="admin-textfiled">
                              {/* <TextField
                                aria-label="minimum height"
                                required
                                disabled={role === "juniorDesigner"}
                                label="cost"
                                placeholder="Enter cost"
                                value={amount}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => {
                                  setAmount(e.target.value);
                                  clearError("amount");
                                }}
                                error={!!errors.amount}
                                helperText={errors.amount}

                              /> */}
                              <TextField
                                aria-label="minimum height"
                                required
                                // disabled={role === "juniorDesigner"}
                                label="Cost"
                                placeholder="Enter cost"
                                value={amount}
                                InputLabelProps={{ shrink: true }}

                                // Allow only digits on typing
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                }}

                                onChange={(e) => {
                                  const value = e.target.value;

                                  // Allow empty input
                                  setAmount(value);
                                  clearError("amount");
                                }}

                                error={!!errors.amount}
                                helperText={errors.amount}
                              />

                            </div>
                          </Grid>
                        )}
                      </>
                    )}

                    {currentStep === 2 && !subOrder.final_image ? (
                      <>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                          <div className="admin-textfiled">
                            <TextField
                              required
                              type="file"
                              label="finalImage"
                              placeholder="Enter finalImage"
                              onChange={handleFileChangeimage}
                              accept="image/*"
                              inputProps={{ accept: "image/*" }}
                              InputLabelProps={{ shrink: true }}
                              error={!!errors.finalImage}
                              helperText={errors.finalImage}
                            />
                          </div>

                        </Grid>
                        {role !== "JuniorDesigner" && (
                          <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                            {/* <div className="admin-textfiled">
                            <TextField
                                aria-label="minimum height"
                                required
                                disabled={role === "juniorDesigner"}
                                label="cost"
                                placeholder="Enter cost"
                                value={amount}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => {
                                  setAmount(e.target.value);
                                  clearError("amount");
                                }}
                                error={!!errors.amount}
                                helperText={errors.amount}

                              /> 
                            </div>
                            */}

                            <div className="admin-textfiled">
                              <TextField
                                aria-label="minimum height"
                                required
                                // disabled={role === "JuniorDesigner"}
                                label="Cost"
                                placeholder="Enter cost"
                                value={amount}
                                InputLabelProps={{ shrink: true }}

                                // Allow only digits on typing
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                }}

                                onChange={(e) => {
                                  const value = e.target.value;

                                  // Allow empty input
                                  setAmount(value);
                                  clearError("amount");
                                }}

                                error={!!errors.amount}
                                helperText={errors.amount}
                              />

                            </div>
                          </Grid>
                        )}
                      </>
                    ) : (
                      ""
                    )}

                    {(role !== "JuniorDesigner") &&
                      currentStep === 3 &&
                      !subOrder.DeliveryBoy && (
                        <>
                          <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                            <div className="admin-textfiled">
                              <FormControl fullWidth required error={!!errors.deliveryboy}>
                                <InputLabel id="demo-simple-select-label">
                                  Assign Delivery Boy
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  label="Assign Delivery Boy"
                                  value={deliveryboy || subOrder?.DeliveryBoy}
                                  onChange={(e) => {
                                    setDeliveryboy(e.target.value);
                                    clearError("deliveryboy");
                                  }}
                                >
                                  {staff.filter(
                                    (data) => data?.Designation === "Delivery Boy"
                                  ).length > 0 ? (
                                    staff?.filter((data) => data?.Designation === "Delivery Boy")
                                      .map((data, index) => (
                                        <MenuItem key={index} value={data?.staffId}>
                                          {data.DesignationName}
                                        </MenuItem>
                                      ))
                                  ) : (
                                    <MenuItem disabled>No Data Found</MenuItem>
                                  )}
                                </Select>
                                {errors.deliveryboy && (<FormHelperText>{errors.deliveryboy}</FormHelperText>)}
                              </FormControl>
                            </div>
                          </Grid>

                          {role !== "JuniorDesigner" && (
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                              <div className="admin-textfiled">
                                {/* <TextField
                                  aria-label="minimum height"
                                  required
                                  label="cost"
                                  placeholder="Enter cost"
                                  value={amount}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={(e) => {
                                    setAmount(e.target.value);
                                    clearError("amount");
                                  }}
                                  error={!!errors.amount}
                                  helperText={errors.amount}
                                /> */}
                                <div className="admin-textfiled">
                                  <TextField
                                    aria-label="minimum height"
                                    required
                                    // disabled={role === "JuniorDesigner"}
                                    label="Cost"
                                    placeholder="Enter cost"
                                    value={amount}
                                    InputLabelProps={{ shrink: true }}

                                    // Allow only digits on typing
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                    }}

                                    onChange={(e) => {
                                      const value = e.target.value;

                                      // Allow empty input
                                      setAmount(value);
                                      clearError("amount");
                                    }}

                                    error={!!errors.amount}
                                    helperText={errors.amount}
                                  />

                                </div>
                              </div>
                            </Grid>
                          )}
                        </>
                      )}

                    {currentStep === 1 && (
                      <>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                          <div className="admin-textfiled">
                            <FormControl fullWidth required error={!!errors.master}>
                              <InputLabel id="demo-simple-select-label">
                                Assign Master
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Assign Master"
                                value={master || subOrder?.Master}
                                onChange={(e) => {
                                  setMaster(e.target.value);
                                  clearError("master");
                                }}
                              >
                                {staff?.filter(
                                  (data) => data?.Designation === "Master"
                                ).length > 0 ? (
                                  staff?.filter((data) => data?.Designation === "Master")
                                    .map((data, index) => (
                                      <MenuItem
                                        key={index}
                                        value={data.DesignationName}
                                      >
                                        {data.DesignationName}
                                      </MenuItem>
                                    ))
                                ) : (
                                  <MenuItem disabled>No Data Found</MenuItem>
                                )}
                              </Select>
                              {errors.master && (<FormHelperText>{errors.master}</FormHelperText>)}
                            </FormControl>
                          </div>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                          <div className="admin-textfiled">
                            <FormControl fullWidth required error={!!errors.tailor}>
                              <InputLabel id="demo-simple-select-label">
                                Assign Tailor
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Assign Tailor"
                                value={tailor || subOrder?.Tailor}
                                onChange={(e) => {
                                  setTailor(e.target.value);
                                  clearError("tailor");
                                }}
                              >
                                {staff.filter(
                                  (data) => data?.Designation === "Tailor"
                                ).length > 0 ? (
                                  staff.filter((data) => data?.Designation === "Tailor")
                                    .map((data, index) => (
                                      <MenuItem
                                        key={index}
                                        value={data.DesignationName}
                                      >
                                        {data.DesignationName}
                                      </MenuItem>
                                    ))
                                ) : (
                                  <MenuItem disabled>No Data Found</MenuItem>
                                )}
                              </Select>
                              {errors.tailor && (<FormHelperText>{errors.tailor}</FormHelperText>)}
                            </FormControl>
                          </div>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                          <div className="admin-textfiled">
                            <FormControl fullWidth required error={!!errors.maggamWorker}>
                              <InputLabel id="demo-simple-select-label">
                                Assign Maggam worker
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Assign Maggam worker"
                                value={maggamWorker || subOrder?.MaggamWorker}
                                onChange={(e) => {
                                  setMaggamWorker(e.target.value);
                                  clearError("maggamWorker");
                                }}
                              >
                                {staff?.filter(
                                  (data) =>
                                    data?.Designation === "Maggam Worker" ||
                                    data?.Designation === "Maggama Worker"
                                ).length > 0 ? (
                                  staff?.filter((data) =>
                                    data?.Designation === "Maggam Worker" ||
                                    data?.Designation === "Maggama Worker")
                                    .map((data, index) => (
                                      <MenuItem
                                        key={index}
                                        value={data?.DesignationName}
                                      >
                                        {data?.DesignationName}
                                      </MenuItem>
                                    ))
                                ) : (
                                  <MenuItem disabled>No Data Found</MenuItem>
                                )}
                              </Select>
                              {errors.maggamWorker && (<FormHelperText>{errors.maggamWorker}</FormHelperText>)}
                            </FormControl>
                          </div>
                        </Grid>
                        {role === "JuniorDesigner" ? null : (
                          <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                            <div className="admin-textfiled">
                              {/* <TextField
                                aria-label="minimum height"
                                required
                                disabled={role === "juniorDesigner"}
                                label="cost"
                                InputLabelProps={{ shrink: true }}
                                placeholder="Enter cost"
                                value={amount}
                                // value={amount !== undefined && amount !== null ? amount : subOrder?.amount !== undefined && subOrder?.amount !== null ? subOrder?.amount : ""}
                                onChange={(e) => {
                                  setAmount(e.target.value);
                                  clearError("amount");
                                }}
                                error={!!errors.amount}
                                helperText={errors.amount}
                              />
                              */}

                              <TextField
                                aria-label="minimum height"
                                required
                                // disabled={role === "juniorDesigner"}
                                label="Cost"
                                placeholder="Enter cost"
                                value={amount}
                                InputLabelProps={{ shrink: true }}

                                // Allow only digits on typing
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                }}

                                onChange={(e) => {
                                  const value = e.target.value;

                                  // Allow empty input
                                  setAmount(value);
                                  clearError("amount");
                                }}

                                error={!!errors.amount}
                                helperText={errors.amount}
                              />
                            </div>
                          </Grid>
                        )}
                      </>
                    )}

                  </Grid>
                </div>
              </Grid>

              <Grid item size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                <Box className="info-card">
                  <Typography variant="h6" className="card-title">Status & Actions</Typography>
                  {['Order Canceled', "Order Processed", "Order Delivered", "Delivery Scheduled"].includes(subOrder?.status) &&
                    <div className="status-display-wrapper">
                      <OrderStatusDisplay status={subOrder?.status} />
                    </div>}
                  {shouldShowActionButtons() && (
                    <>
                      <TextField label="Internal Comment" multiline rows={3} value={comment || ''} onChange={(e) => setcomment(e.target.value)} fullWidth />
                    </>
                  )}
                  <Box className="action-buttons">
                    {shouldShowActionButtons() && (
                      <>
                        {role === 'Admin' ? <Button variant="outlined" color="error" onClick={() => handelCancelOrder(subOrder._id)}>Cancel</Button> : null}
                        <Button variant="contained" disabled={buttondis} onClick={() => handleupdateorder(subOrder._id)}>{`${(currentStep === 2 && !subOrder.final_image) ? `Upload & Save Changes` : `Assign & Save Changes`}`}</Button>
                      </>
                    )}
                    {subOrder?.DeliveryBoy && subOrder?.status !== "Order Delivered" && role !== "JuniorDesigner" && (
                      <Button variant="contained" color="success" disabled={buttondis} onClick={() => handleupdateorder(subOrder._id, "Delivered")}>Mark as Delivered</Button>
                    )}
                    {/* {subOrder.final_image_approval === false && subOrder.final_image && (!role === "juniorDesigner" || role === "Admin" || "SeniorDesigner") && (
                      <Button variant="contained" color="info" onClick={() => setOpenDialog(true)}>Approve Mannequin</Button>
                    )} */}
                    {subOrder.final_image_approval === false &&
                      subOrder.final_image &&
                      role !== "JuniorDesigner" && (
                        <Button variant="contained" color="info" onClick={() => setOpenDialog(true)}>
                          Approve Mannequin
                        </Button>
                      )}

                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={openConsultationDialog}
          className="admin-admins"
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {"Cancel Order"}
            <div className="consultation-popup"></div>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <section className="add-consultantation">
              <Typography variant="h5">
                Are you sure you want to Cancel Order?
              </Typography>
            </section>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} className="cancel-btn">
              Cancel
            </Button>
            <Button
              className="add-btn"
              onClick={() => {
                // perform action here
                // setstatus('Canceled');
                handleupdateorder(subOrder._id, null, "Order Canceled");
              }}
              autoFocus
            >
              Confirm
            </Button>
          </DialogActions>
        </BootstrapDialog>

        <BootstrapDialog
          onClose={handleCloseViewMore}
          open={openViewMoreDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle className="suboreder_info_title">
            Sub Order Details
            <IconButton
              aria-label="close"
              onClick={handleCloseViewMore}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <div className="suboreder_info_content">

              {/* Order Details Section */}
              <section className="suborder-section">
                <Typography variant="h6" className="section-title">Order Details</Typography>
                <div className="info-grid">
                  <p><strong>Order ID:</strong> {subOrder?.sub_order_id || "---"}</p>
                  {/* <p><strong>Customer Name:</strong> {subOrder?.customer_id?.name || "---"}</p> */}
                  <p><strong>Status:</strong> {subOrder?.status || "---"}</p>
                  <p><strong>Amount:</strong> ₹{subOrder?.amount || "---"}</p>
                  <p><strong>Quantity:</strong> {subOrder?.quantity || "---"}</p>
                  <p><strong>Size:</strong> {subOrder?.size || "---"}</p>
                  <p><strong>Fabric Given:</strong> {subOrder?.fabric_given ? "Yes" : "No"}</p>
                  <p><strong>Order For:</strong> {subOrder?.ordered_for || "---"}</p>
                  <p><strong>Deadline:</strong>  {subOrder?.deadline
                    ? dayjs(subOrder.deadline).format("DD-MM-YYYY")
                    : "---"}</p>

                </div>
                {subOrder?.AlterationReason && <div className="info-grid">
                  <p><strong>Alteration Reason:</strong> {subOrder?.AlterationReason || "---"}</p>
                </div>
                }
              </section>

              {/* Assigned People Section */}
              <section className="suborder-section">
                <Typography variant="h6" className="section-title">Assigned Team</Typography>
                <div className="info-grid">
                  <p><strong>Assigned To:</strong> {subOrder?.assigned_to?.name || "Not Assigned"}</p>
                  <p><strong>Master:</strong> {subOrder?.Master || "Not Assigned"}</p>
                  <p><strong>Tailor:</strong> {subOrder?.Tailor || "Not Assigned"}</p>
                  <p><strong>Maggam Worker:</strong> {subOrder?.MaggamWorker || "Not Assigned"}</p>
                  <p><strong>Delivery Boy:</strong> {subOrder?.DeliveryBoy || "Not Assigned"}</p>
                </div>
              </section>

              {/* Comments */}
              {subOrder?.comment && (
                <section className="suborder-section">
                  <Typography variant="h6" className="section-title">Comment</Typography>
                  <p className="comment">{subOrder.comment}</p>
                </section>
              )}

              {/* Fabric Images */}
              {(
                (subOrder?.fabric_given === true && subOrder?.fabric_img?.length > 0) ||
                (subOrder?.design_id?.fabric_img?.length > 0)
              ) && (
                  <section className="suborder-section">
                    <Typography variant="h6" className="section-title">Fabric Images</Typography>

                    <Grid container spacing={2}>
                      {(subOrder?.fabric_given === true && subOrder?.fabric_img?.length > 0
                        ? subOrder.fabric_img
                        : subOrder?.design_id?.fabric_img
                      ).map((img, idx) => (
                        <Grid item key={idx} size={{ sm: 12, md: 12, lg: 2 }}>
                          <Image
                            src={img}
                            alt={`Fabric ${idx + 1}`}
                            width={200}
                            height={200}
                            className="suborder-image"
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </section>
                )}


              {/* Design Images */}
              {subOrder?.design_id?.picture?.length > 0 && (
                <section className="suborder-section">
                  <Typography variant="h6" className="section-title">Design Images</Typography>
                  <Grid container spacing={2}>
                    {subOrder.design_id.picture.map((img, idx) => (
                      <Grid item size={{ sm: 12, md: 12, lg: 2 }} key={idx}>
                        <Image
                          src={img}
                          alt={`Design ${idx + 1}`}
                          className="suborder-image"
                          width={200}
                          height={200}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </section>
              )}

              {/* Final Image */}
              {subOrder?.final_image && (
                <section className="suborder-section">
                  <Typography variant="h6" className="section-title">Final Image</Typography>
                  <Image
                    src={subOrder?.final_image}
                    alt="Final Design"
                    className="suborder-image full"
                    width={200}
                    height={200}
                  />
                </section>
              )}

              {/* Documents */}
              {subOrder?.documents?.length > 0 && (
                <section className="suborder-section">
                  <Typography variant="h6" className="section-title">Documents</Typography>
                  <ul className="document-list">
                    {subOrder.documents.map((doc, idx) => (
                      <li key={idx}>
                        <GetLink
                          href={doc}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Documents
                        </GetLink>
                      </li>
                    ))}
                  </ul>
                </section>
              )}

              {/* Sheet */}
              {subOrder?.sheet && (
                <section className="suborder-section">
                  <Typography variant="h6" className="section-title">Measurement Sheet</Typography>
                  <GetLink
                    href={subOrder.sheet}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="view-link"
                  >
                    View Measurement Sheet
                  </GetLink>
                </section>
              )}
            </div>

          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseViewMore} className="close-btn">Close</Button>
          </DialogActions>
        </BootstrapDialog>

        <ApproveManequinDialog
          openDialog={openDialog}
          handleClose={() => setOpenDialog(false)}
          data={subOrder.final_image}
          handleApprove={finalImageApprove}
        />

      </Box>
    </div>
  );
};


const OrderStatusDisplay = ({ status }) => {
  const config = {
    'Order Delivered': { icon: <CheckCircleOutlineOutlinedIcon />, className: 'status-delivered' },
    'Order Processed': { icon: <AutorenewIcon />, className: 'status-processing' },
    'Order Canceled': { icon: <CancelOutlinedIcon />, className: 'status-canceled' },
  }[status] || { icon: <HelpOutlineIcon />, className: 'status-unknown' };

  return (
    <Box className={`order-status-display-small ${config.className}`}>
      {config.icon}
      <Typography variant="body2">{status}</Typography>
    </Box>
  );
};

export default SubOrder_details;
